export default __webpack_public_path__ + "static/media/Video_Icon.e35b6009.svg";